<dynamic-container #controlRef [config]="config" [formGroup]="group">
  <div class="container-checkbox-special">
    <cwc-checkbox
      [formControl]="ctrlCheckBox"
      [attr.required]="controlRef.isRequired"
      [attr.status]="fieldControl.invalid && !fieldControl.untouched ? 'error' : null"
      [attr.data-test]="config?.dataTId"
      [attr.data-tid]="config?.dataTId"
      [attr.data-name]="config?.name"
      class="m-end-sm"
      [checked]="checked"
      designVersion="v2"
    >
      <label>{{ config.label | translate }}</label>
    </cwc-checkbox>
    <div class="text-left pb-2" *ngIf="checkBoxValue">
      <cwc-textarea
        [maxlength]="config['maxlength']"
        class="text-area-checkbox-special"
        [label]="config.label | translate"
        [placeholder]="config.placeholder | translate"
        [formControlName]="config.name"
        designVersion="v2"
        no-resize
        [charCounter]="config['maxlength']"
      ></cwc-textarea>
    </div>
  </div>
</dynamic-container>
